<template>
  <div :class="$style.auth">
    <div class="pt-5 pb-5 d-flex align-items-end mt-auto">
      <img src="/resources/images/air-logo.png" alt="neoskool Logo" />
      <div class="air__utils__logo__text">
        <div class="air__utils__logo__name text-uppercase text-dark font-size-21">neoskool</div>
        <div class="air__utils__logo__descr text-uppercase font-size-12 text-gray-6">School Management</div>
      </div>
    </div>
    <div class="pl-5 pr-5 pt-5 pb-5 bg-white text-center" :class="$style.container">
      <div class="text-dark font-size-30 mb-4">Password reset link sent</div>
      <div class="bg-light p-4 text-left">
        <p class="h5 mb-0">The password reset link has been sent successfully! Please check your register email for our mail and follow the provided instruction.</p>
      </div>
    </div>
    <div class="text-center font-size-18 pt-4 mb-auto">
      <router-link to="/system/login" class="font-weight-bold text-blue">
        <i class="fe fe-arrow-left align"></i> Go Back
      </router-link>
    </div>
    <div class="mt-auto pb-5 pt-5">
      <!-- <ul
        class="list-unstyled d-flex mb-2 flex-wrap justify-content-center"
        :class="$style.footerNav"
      >
        <li>
          <a href="#">Terms of Use</a>
        </li>
        <li>
          <a href="#">Compliance</a>
        </li>
        <li>
          <a href="#">Support</a>
        </li>
        <li>
          <a href="#">Contacts</a>
        </li>
      </ul> -->
      <div class="text-gray-4 text-center">© 2019 neoskool. All rights reserved.</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NeoResetLinkSent',
  data: function() {
    return {
      form: this.$form.createForm(this),
      resetCode: null,
    }
  },
  created: function() {
    this.resetCode = this.$route.query.reset_code
    this.email = this.$route.query.email
  },
  methods: {
    handleConfirmBlur (e) {
      const value = e.target.value
      this.confirmDirty = this.confirmDirty || !!value
    },
    compareToFirstPassword (rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('password')) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('Not same with the password!')
      } else {
        callback()
      }
    },
    validateToNextPassword (rule, value, callback) {
      const form = this.form
      if (value && this.confirmDirty) {
        form.validateFields(['confirm_password'], { force: true })
      }
      callback()
    },
    handleSubmit(e) {
      e.preventDefault()
      // this.$router.push({ name: 'resetpassword', query: { email: 'email', reset_code: 'code' } })
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$nprogress.start()
          this.$auth
            .forgotPassword(this.email, this.resetCode, values.password)
            .then(({ data }) => {
              this.$nprogress.done()
              this.$router.push({ name: 'login' })
              this.$notification['success']({
                message: 'Successfully Reset!',
                description: 'Your password has been reset successfully!',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        }
      })
    },
  },
}
</script>
<style lang="scss" module>
@import "@/components/system/Auth/style.module.scss";
</style>
